import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { PaginateReqEntity, PaginateRespEntity } from '../../../interface';
import { IsFormValid, displayDateFormat, scrollTop, checkActionAuthorization } from '../../../service/shared.service';
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from '../../../utils/null-check';
import { searchInputPlaceholder, toastOptObj } from "../../../utils/constants";
import { TBSTypeEnumEntity } from '../../../utils/enum';
import { toast } from 'react-toastify';
import { RadioButton } from 'primereact/radiobutton';
import { AxiosResponse } from 'axios';
import { APIResponseEntity } from '../../../interface/api-responce';
import { APIToCreateTBSCategory, APIToDeleteTBSCategory, APIToGetTBSCategories, APIToUpdateTBSCategory } from '../../../service/api-service';
import Loader from '../../../components/loader';
import { DataTable, DataTableSortEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DeleteConfirmationDialog from '../../../components/delete-confirmation';
import PrimePaginator from '../../../components/prime-paginator';
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { TBSCategoryDetailsEntity } from '../../../interface/tbs-category';
declare var $: any;

const TBS_TYPE_OPTIONS = [
    { name: 'Skin', code: TBSTypeEnumEntity.SKIN },
    { name: 'Hardware', code: TBSTypeEnumEntity.HARDWARE },
];

const TBS_TYPE_LABEL: Record<string, string> = {
    [TBSTypeEnumEntity.SKIN]: 'Skin',
    [TBSTypeEnumEntity.HARDWARE]: 'Hardware',
};

const NAME_REQUIRED = 'Please enter TBS category name';

function TBSCategory() {

    const navigate = useNavigate();

    const [name, setName] = useState<string>('');

    const [tbsType, setTbsType] = useState<TBSTypeEnumEntity>(TBSTypeEnumEntity.SKIN);

    const [status, setStatus] = useState<boolean>(true);

    const [formErrors, setFormErrors] = useState<{ name: string }>({ name: NAME_REQUIRED });

    const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [filterReq, setFilterReq] = useState<PaginateReqEntity>({
        pageSize: 10,
        pageNumber: 0,
        searchText: '',
        sortColumn: 'createdAt',
        sortOrder: '-1'
    });

    const [searchKeyword, setSearchKeyword] = useState<string>('');

    const [categoryDetails, setCategoryDetails] = useState<TBSCategoryDetailsEntity[] | []>([])

    const [totalPageCount, setTotalPageCount] = useState(0);

    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>('');

    const [isUpdateRecordId, setIsUpdateRecordId] = useState<string>('');

    const [isEdit, setIsEdit] = useState<boolean>(false);

    const Status = [
        { name: 'Active', code: true },
        { name: 'Inactive', code: false },
    ];

    useEffect(() => { return () => { toast.dismiss(); }; }, []);

    useEffect(() => {
        const fetchData = async (): Promise<void> => {
            await fetchCategories();
        };
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterReq]);

    useEffect(() => {
        $("#id_of_searchbox").keyup((event: any) => {
            const searchText: string = IsStringNullEmptyOrUndefined(event.target.value) ? '' : event.target.value;

            if (event.keyCode === 13 &&
                (
                    (IsStringNullEmptyOrUndefined(searchText))
                    ||
                    (!IsStringNullEmptyOrUndefined(searchText) && searchText.length >= 3)
                )
            ) {
                setFilterReq((prev) => ({ ...prev, searchText, pageNumber: 0 }));
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchCategories = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIToGetTBSCategories(filterReq);
        setCategoryDetails([]);
        setTotalPageCount(0);

        if (resp) {
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;

                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setCategoryDetails(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                }
            }
            else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }

        setIsLoading(false);
    };

    // any characters are allowed in the name, it just cannot be blank
    const handleNameChange = (value: string) => {
        setFormErrors({ name: IsStringNullEmptyOrUndefined(value.trim()) ? NAME_REQUIRED : '' });
        setName(value);
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setIsFormSubmitted(true);
        const isValid = IsFormValid(formErrors);
        if (isValid) {
            setIsFormSubmitted(false);
            try {
                setIsLoading(true);
                const reqObj = { name: name.trim(), tbsType, isActive: status };
                const resp: AxiosResponse<APIResponseEntity> = isEdit
                    ? await APIToUpdateTBSCategory(isUpdateRecordId, reqObj)
                    : await APIToCreateTBSCategory(reqObj);
                if (resp) {
                    if (resp.data && (resp.status === 200 || resp.status === 201)) {
                        const axiosResp: APIResponseEntity = resp.data;
                        if (axiosResp && axiosResp.status &&
                            (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                            toast.success(axiosResp.message, { ...toastOptObj });
                            resetForm();
                            setFilterReq({ ...filterReq, pageNumber: 0 });
                        } else {
                            toast.error(axiosResp.message, { ...toastOptObj });
                        }
                    }
                    else {
                        toast.error(resp.data.message, { ...toastOptObj });
                    }
                }
                setIsLoading(false);
            }
            catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        };
    };

    const deleteCategory = async (value: boolean) => {
        if (!value) { return; }
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIToDeleteTBSCategory(isDeleteRecordId);
        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.status && axiosResp.statusCode === 200) {
                    toast.success(axiosResp.message, { ...toastOptObj });
                    resetForm();
                    setFilterReq({ ...filterReq, pageNumber: 0 });
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
            else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }
        setIsLoading(false);
    }

    const updateCategory = (rowData: TBSCategoryDetailsEntity) => {
        setName(rowData.name);
        setTbsType(rowData.tbsType === TBSTypeEnumEntity.HARDWARE ? TBSTypeEnumEntity.HARDWARE : TBSTypeEnumEntity.SKIN);
        setStatus(rowData.isActive ?? true);
        setFormErrors({ name: !IsStringNullEmptyOrUndefined(rowData.name) ? '' : NAME_REQUIRED });
        setIsUpdateRecordId(rowData.id);
        setIsEdit(true);
    }

    const dateCreatedBodyTemplate = (rowData: TBSCategoryDetailsEntity) => {
        return displayDateFormat(rowData.createdAt as string);
    };

    const dateUpdatedBodyTemplate = (rowData: TBSCategoryDetailsEntity) => {
        return displayDateFormat(rowData.updatedAt as string);
    };

    const typeBodyTemplate = (rowData: TBSCategoryDetailsEntity) => {
        return TBS_TYPE_LABEL[rowData.tbsType] ?? rowData.tbsType;
    };

    const actionIconTemplate = (rowData: TBSCategoryDetailsEntity) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">
                {checkActionAuthorization('update', 'TBS Category') &&
                    <li data-toggle="tooltip" title="Edit">
                        <img src="assets/images/edit-icon.svg" alt="Edit" onClick={() => { updateCategory(rowData); scrollTop(); }} />
                    </li>}
                {checkActionAuthorization('delete', 'TBS Category') &&
                    <li data-toggle="tooltip" title="Delete" onClick={() => setIsDeleteRecordId(rowData.id)}>
                        <DeleteConfirmationDialog
                            isAccepted={deleteCategory}
                        />
                    </li>}
            </ul>
        );
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFilterReq({ ...filterReq, pageSize: event.rows, pageNumber: event.page });
    };

    const onSort = (event: DataTableSortEvent) => {
        setFilterReq({ ...filterReq, sortColumn: event.sortField, sortOrder: String(event.sortOrder), pageNumber: 0 });
    };

    const statusBodyTemplate = (rowData: TBSCategoryDetailsEntity) => {
        return <span className={`badge badge-${rowData.isActive === true ? "success" : "danger"}`}> {rowData.isActive ? "Active" : "Inactive"}</span>;
    };

    const resetForm = (): void => {
        setIsUpdateRecordId('');
        setName('');
        setTbsType(TBSTypeEnumEntity.SKIN);
        setStatus(true);
        setFormErrors({ name: NAME_REQUIRED });
        setIsFormSubmitted(false);
        setIsEdit(false);
    }

    return (
        <>
            <Loader isLoading={isLoading} />

            <div className="content-wrapper">
                <div className='col-12'>
                    <div className='row'>
                        <div className="col-lg-4 col-md-4 mb-md-0 mb-3">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <h4 className="card-title">TBS Category</h4>
                                        </div>
                                    </div>
                                    {checkActionAuthorization('create', 'TBS Category') ?
                                        <form onSubmit={handleSubmit}>

                                            <div className="form-group mb-3">
                                                <label>TBS CATEGORY NAME <sup className='mandatory'>*</sup></label>
                                                <input type="text" name='name' className="form-control form-control-lg"
                                                    onChange={(e) => handleNameChange(e.target.value)}
                                                    maxLength={100} value={name}
                                                />
                                                {
                                                    isFormSubmitted &&
                                                    <small className="text-danger font-weight-500">
                                                        {formErrors.name}
                                                    </small>
                                                }
                                            </div>

                                            <div className="form-group">
                                                <label>TBS TYPE <sup className='mandatory'>*</sup></label>
                                                <div className='d-flex mb-2'>
                                                    {TBS_TYPE_OPTIONS.map((option) => (
                                                        <div key={option.code} className="d-flex align-items-center mb-2">
                                                            <RadioButton
                                                                inputId={`tbsType-${option.code}`}
                                                                name="tbsType"
                                                                className='me-2'
                                                                value={option.code}
                                                                onChange={(e) => setTbsType(e.value)}
                                                                checked={tbsType === option.code}
                                                            />
                                                            <label htmlFor={`tbsType-${option.code}`} className='me-5'>{option.name}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>STATUS</label>
                                                <div className='d-flex mb-2'>
                                                    {Status.map((option: any) => (
                                                        <div key={option.code} className="d-flex align-items-center mb-2">
                                                            <RadioButton
                                                                inputId={`status-${option.code}`}
                                                                name="status"
                                                                className='me-2'
                                                                value={option.code}
                                                                onChange={(e) => setStatus(e.value)}
                                                                checked={status === option.code}
                                                            />
                                                            <label htmlFor={`status-${option.code}`} className='me-5'>{option.name}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className='col-12'>
                                                <button type="submit" className="btn btn-block  btn-primary btn-md font-weight-medium m-0 me-2"
                                                >Save TBS Category</button>

                                                <button
                                                    type="button"
                                                    className="btn btn-cancel text-dark m-0"
                                                    onClick={() => IsStringNullEmptyOrUndefined(isUpdateRecordId) ? navigate('/settings') : resetForm()}>
                                                    {IsStringNullEmptyOrUndefined(isUpdateRecordId) ? 'Cancel' : 'Clear'}
                                                </button>
                                            </div>
                                        </form> : <div className="alert alert-danger" role="alert">
                                            You don't have permission to create TBS categories
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8">
                            <div className="card card-rounded">
                                <div className='card-body'>
                                    <div className="col-md-7 mb-3 ms-sm-auto">
                                        <div className="input-group search-grp">
                                            <img src="assets/images/search.svg"
                                                alt="search" className="input-group-text searchIptGrpTxt" />

                                            <input type="text" className='form-control form-control-lg searchInput'
                                                placeholder={searchInputPlaceholder}
                                                value={searchKeyword} id="id_of_searchbox"
                                                onChange={(e) => setSearchKeyword(e.target.value)}
                                            />
                                            {!IsStringNullEmptyOrUndefined(searchKeyword) && (
                                                <button
                                                    className="btn btn-cancel text-dark search-button-clear"
                                                    type="button"
                                                    onClick={() => {
                                                        setSearchKeyword('');
                                                        setFilterReq({ ...filterReq, searchText: '', pageNumber: 0 });
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <DataTable value={categoryDetails}
                                            sortField={filterReq.sortColumn}
                                            sortOrder={filterReq.sortOrder ? (parseInt(filterReq.sortOrder) as 1 | -1) : -1}
                                            onSort={onSort}
                                            emptyMessage="No TBS categories found"
                                        >
                                            <Column field="name" header="TBS Category" sortable></Column>
                                            <Column field="tbsType" header="TBS Type" body={typeBodyTemplate} sortable></Column>
                                            <Column body={statusBodyTemplate} header="Status" ></Column>
                                            <Column field="createdAt" header="Created Date" body={dateCreatedBodyTemplate} sortable></Column>
                                            <Column field="updatedAt" header="Last Updated Date" body={dateUpdatedBodyTemplate} sortable></Column>
                                            {(checkActionAuthorization('update', 'TBS Category') || checkActionAuthorization('delete', 'TBS Category')) &&
                                                <Column header="Action" body={actionIconTemplate}></Column>
                                            }
                                        </DataTable>
                                    </div>

                                    {
                                        !IsNullOrEmptyArray(categoryDetails) && <PrimePaginator
                                            onPageChange={onPageChange}
                                            pageNumber={filterReq.pageNumber}
                                            pageSize={filterReq.pageSize}
                                            totalRecords={totalPageCount}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TBSCategory;
